import React from 'react'
import { MainContainer } from '@core/Components/Containers'
import { Notification } from './Components/Notification/Notification'
import { Banner } from '@core/Components/Banner'
import { HomeNavigation } from './Components/HomeNavigation'
import { HomeNextRaces } from './Components/HomeNextRaces'
import { FeaturedItems } from './Components/FeaturedItems'
import { resetMatchedRaceBetTypePersist } from '@classic/Betting-v2/Components/Pages/Workflow/BettingStateManagerViewModel'
import { ActivitySummary } from '@core/Areas/ResponsibleWagering/ActivitySummary'
import { useShareBlackbookIncomingListener } from '@core/Areas/Blackbook/Hooks/useShareBlackbookIncomingListener'
import { ShareBetIncoming } from '@core/Areas/ShareBet/ShareBetIncoming'
import { HomeFooter } from './Components/Footer/HomeFooter'
import { BannerCardStyled, HomeScrollWrapperStyled as ScrollerWrapper } from './Home.styles'
import { useRefreshOnVersionUpgrade } from '@core/Utils/hooks/useRefreshOnVersionUpgrade'
import { TrendingBets } from './Components/TrendingBets/TrendingBets'
import { MarketingOptInBanner } from './Components/MarketingOptInBanner'

export const Home: React.FC = () => {
  useRefreshOnVersionUpgrade()
  useShareBlackbookIncomingListener()

  React.useEffect(() => {
    resetMatchedRaceBetTypePersist()
  }, [])

  return (
    <MainContainer background='grey'>
      <ShareBetIncoming />

      <Notification isDesktop={false} />

      <MarketingOptInBanner />

      <BannerCardStyled>
        <Banner areaName='Home' />
      </BannerCardStyled>

      <HomeNavigation />

      <ScrollerWrapper>
        <HomeNextRaces />
        <FeaturedItems />
        <TrendingBets type='Single' />
        <TrendingBets type='SameRaceMulti' />
      </ScrollerWrapper>

      <ActivitySummary />

      <HomeFooter />
    </MainContainer>
  )
}
